// extracted by mini-css-extract-plugin
module.exports = {"mark":"FilesSpaceMark_mark__vFQFl"};